import type { FilterBarField } from '@cdw-ae/filter-bar-interfaces';
import type {
  NavigationConfig,
  UrlStateConfig,
  UrlStateItem,
} from '@cdw-ae/url-params';

export interface RouteConfigs {
  filterBarConfigs?: Partial<Record<FilterBarId, FilterBarField[]>>;
  urlParamConfigs?: Partial<Record<FilterBarId, UrlStateConfig>>;
  navigationConfig?: NavigationConfig<UrlStateItem>[];
}

export type AppRoute =
  | '/dashboard'
  | '/deviceSearch'
  | '/userCollections'
  | '/designations'
  | '/ouCollections'
  | '/roles'
  | '/reports'
  | '/report-viewer/:reportType'
  | '/jobs/devices/chrome-profile-wipe';

export enum FilterBarId {
  Dashboard = 'dashboard',
  DeviceSearch = 'deviceSearch',
  UserFilters = 'userFilters',
  DesignationFilters = 'designationFilters',
  OuFilters = 'ouFilters',
  RoleFilters = 'roleFilters',
  Reports = 'reports',
  ReportFilters = 'reportFilters',
  ChromeProfileWipeFilters = 'chromeProfileWipeFilters',
}

/**
 * Query parameter prefixes used in URLs for filter state serialization
 * These abbreviated prefixes keep URLs compact and readable
 * Not all FilterBarId values need query param prefixes - some routes don't persist filters to URL
 */
export const FILTER_QUERY_PARAM_PREFIXES: Readonly<
  Partial<Record<FilterBarId, string>>
> = {
  [FilterBarId.Dashboard]: 'db',
  [FilterBarId.DeviceSearch]: 'ds',
  [FilterBarId.Reports]: 'rp',
  [FilterBarId.ChromeProfileWipeFilters]: 'cpw',
  [FilterBarId.ReportFilters]: 'rf',
} as const;

/**
 * Array of all filter query param prefix values for cleanup operations
 */
export const ALL_FILTER_PREFIXES = Object.values(
  FILTER_QUERY_PARAM_PREFIXES
) as readonly string[];
